import React from 'react';
import '../styles/components/UserPersona.css';

const UserPersona = ({ name, image, quote, favorite }) => {
  return (
    <div className="user-persona">
      <div className="persona-image">
        <img src={image} alt={`${name} - Texas Craft Wings Customer`} />
      </div>
      <div className="persona-content">
        <h3>{name}</h3>
        <p className="persona-quote">"{quote}"</p>
        <p className="persona-favorite">
          <strong>Favorite Special:</strong> {favorite}
        </p>
      </div>
    </div>
  );
};

export default UserPersona;
